// extracted by mini-css-extract-plugin
module.exports = {"a-view":"page_a-view__BVIJ9"};